(function() {
    var x, i, j, l, ll, selElmnt, a, b, c;

    /* Look for any elements with the class 'location-filter-select': */
    x = document.getElementsByClassName('location-filter-select-wrapper');
    l = x.length;

    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName('select')[0];
        ll = selElmnt.length;

        /* For each element, create a new div that will act as the selected item: */
        a = document.createElement('div');
        a.setAttribute('class', 'select-selected');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);

        /* For each element, create a new div that will contain the option list: */
        b = document.createElement('div');
        b.setAttribute('class', 'select-items select-hide');

        for (j = 1; j < ll; j++) {
            /* For each option in the original select element,
            create a new div that will act as an option item: */
            c = document.createElement('div');
            c.innerHTML = selElmnt.options[j].innerHTML;

            c.addEventListener('click', function() {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h, sl, yl;

                s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                sl = s.length;
                h = this.parentNode.previousSibling;

                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML === this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName('same-as-selected');
                        yl = y.length;

                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute('class');
                        }

                        this.setAttribute('class', 'same-as-selected');
                        break;
                    }
                }
                h.click();
                filterValueChange(event);
            });
            b.appendChild(c);
        }

        x[i].appendChild(b);
        a.addEventListener('click', function(e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle('select-hide');
            this.classList.toggle('select-arrow-active');
        });
    }

    function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName('select-items');
        y = document.getElementsByClassName('select-selected');
        xl = x.length;
        yl = y.length;

        for (i = 0; i < yl; i++) {
            if (elmnt === y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove('select-arrow-active');
            }
        }

        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add('select-hide');
            }
        }
    }

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener('click', closeAllSelect);


    /* Filter all contacts by location */
    function filterValueChange() {
        var getAllContacts = document.querySelectorAll('.tx_ewcontact .contact-wrapper');

        getAllContacts.forEach(contactLocationValue);
        document.querySelectorAll('.tx_ewcontact .subarea-wrapper').forEach(checkSubareaForContacts);
    }

    // Get data-location value and compare to selected value -> if true show contact
    function contactLocationValue(event) {
        var locationFilterSelectValue = document.querySelector('.tx_ewcontact .location-filter-select').value;
        var contactDataValue = event.dataset.location.split(',');

        // set all contacts display: none
        event.style.display = 'none';

        if (contactDataValue.includes(locationFilterSelectValue)) {
            // show only contacts with same data-location value as selected
            event.style.display = 'flex';
        }
    }

    // Check if subarea has contacts
    function checkSubareaForContacts(event) {
        var numberOfContacts = event.querySelectorAll('.contact-wrapper').length;
        var numberOfHiddenContacts = event.querySelectorAll('.contact-wrapper[style="display: none;"]').length;

        event.querySelector('.subarea-empty').style.display = 'none';

        if (event.querySelector('.contact-wrapper') === null || numberOfContacts === numberOfHiddenContacts) {
            event.querySelector('.subarea-empty').style.display = 'block';
        }
    }

    document.querySelectorAll('.tx_ewcontact .subarea-wrapper').forEach(checkSubareaForContacts);
})();
